/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_TitleInputs */

const cs_contacts_title = /** @type {(inputs: Contacts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakty`)
};

const en_contacts_title = /** @type {(inputs: Contacts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Contacts_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_title = /** @type {((inputs?: Contacts_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_title(inputs)
	return cs_contacts_title(inputs)
});